export default __webpack_public_path__ + "static/media/fill-blanks-title.f63406bd.webp";